module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-customers/user-edit/user-edit.component.scss
// module id = ./src/app/components/admin/admin-customers/user-edit/user-edit.component.scss
// module chunks = main